import React, { useEffect, useRef, useState } from 'react';

import SecondaryNavBar from '../../../Components/SecondaryNavBar/SecondaryNavBar';

import LoadingOverlay from 'Components/LoadingOverlay/LoadingOverlay';
import { useSelector } from "react-redux";
import { changementNom, postFormulaire } from "../../../api/envoiMailService";
import { checkInvalidNom, renderError, upperCaseRemoveAccent } from "../../../utils/formUtils";
import MessageInfoEnvoi from "../../../Components/Formulaire/MessageInfoEnvoi/MessageInfoEnvoi";
import { getLabelInput } from "../../../utils/stringUtils";
const CONF = window?.confPub;

export default function ChangementNom(
    {
        isInside
    }
) {

    const {
        detailPersonne,
        contrat,
        contratsBeneficiaires,
        infosComplementaires,
        keycloakReduce,
    } = useSelector(state => ({
        ...state.gestionContratReducer,
        ...state.keycloakReducer,
    }))

    const COMMUN_INPUTS = CONF?.UI?.FORMULAIRES?.COMMUN_INPUTS
    const JUSTIFICATIF_NOM = COMMUN_INPUTS?.JUSTIFICATIF_NOM

    const [submitted, setSubmitted] = useState(false)
    const [disabledForm, setDisabledForm] = useState(false)
    const [sendSuccess, setSendSuccess] = useState({
        isSuccess: false,
        message: false,
        display: false,
    })
    const [idBeneficiaireSelected, setIdBeneficiaireSelected]= useState()
    const [documentJustificatif, setDocumentJustificatif] = useState()
    const documentJustificatifRef = useRef(null);
    // TODO contrôler
    const [nouveauNom, setNouveauNom] = useState({
        name: COMMUN_INPUTS?.NOM?.NAME,
        value: '',
        invalid: COMMUN_INPUTS?.NOM?.ERRORS?.MANDATORY,
    })

    const handleOptionChange = (e) => {

        setIdBeneficiaireSelected(e?.target?.value)
    }

    const handleFileChange = (e) => {

        setDocumentJustificatif(e.target.files[0]);
    }

    const handleNouveauNom = (e) => {

        const value = upperCaseRemoveAccent(e?.target?.value)

        const invalid = checkInvalidNom(value, COMMUN_INPUTS?.NOM?.NAME)

        setNouveauNom((prev) => ({
            ...prev,
            value: value,
            invalid: invalid,
        }))
    }

    const handleSubmit = async (e) => {

        e.preventDefault()
        setDisabledForm(true)

        const invalidNom = checkInvalidNom(nouveauNom?.value, COMMUN_INPUTS?.NOM?.NAME)

        setNouveauNom((prev) => ({
            ...prev,
            invalid: invalidNom,
        }))

        if (idBeneficiaireSelected && documentJustificatif && !invalidNom) {

            const contratBeneficiaire = contratsBeneficiaires.find(({ idUniqueGrc }) => idUniqueGrc === idBeneficiaireSelected)

            try {

                const resp = await changementNom(keycloakReduce?.decodedToken?.idGrm, keycloakReduce?.decodedToken?.email,
                    detailPersonne, contratBeneficiaire, nouveauNom?.value, documentJustificatif)

                console.log("resp")
                console.log(resp)

                setSendSuccess({
                    isSuccess: true,
                    message: false,
                    display: true,
                })

            } catch (err) {

                setSendSuccess({
                    isSuccess: false,
                    message: false,
                    display: true,
                })

                setSubmitted(true)

            } finally {

                setDisabledForm(false)
            }

        } else {
            setDisabledForm(false)
            setSubmitted(true)
        }
    }

    const erasedInputs = (all) => {

        setSubmitted(false)

        setNouveauNom((prev) => ({
            ...prev,
            value: '',
            invalid: COMMUN_INPUTS?.NOM?.ERRORS?.MANDATORY,
        }))

        setIdBeneficiaireSelected(null)
        setDocumentJustificatif(null)

        if (documentJustificatifRef?.current) {
            documentJustificatifRef.current.value = null
        }

        if (all) {

            setSendSuccess({
                isSuccess: false,
                message: false,
                display: false,
            })
        }
    }

    return (
        <div className="container mt-3">
            { !isInside && <SecondaryNavBar /> }
            <main id='content' className='overlay-container'>

                { disabledForm && <LoadingOverlay classes="upload-overlay"/> }

                <div className={ `${ !isInside ? 'col-lg-8' : '' }` }>
                    <div className="card">

                        <form onSubmit={ handleSubmit }>
                            <div className="card-header">
                                <h2>Changement de nom de famille</h2>
                            </div>

                            <div className="card-body">

                                <h3>Sélectionnez le bénéficiaire concerné :</h3>

                                { contratsBeneficiaires?.length > 0 && contratsBeneficiaires.map(contrat => (
                                    <div  key={ contrat?.idUniqueGrc }>
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="contrat"
                                                value={ contrat?.idUniqueGrc }
                                                checked={ idBeneficiaireSelected === contrat?.idUniqueGrc }
                                                id={ contrat?.idUniqueGrc }
                                                onChange={ handleOptionChange }
                                            />
                                            <label
                                                className="form-check-label"
                                                htmlFor={ contrat?.idUniqueGrc }>
                                                { contrat?.civilite } { contrat?.prenom } { contrat?.nom }
                                            </label>
                                        </div>
                                        { submitted && !idBeneficiaireSelected
                                            && renderError("Vous devez sélectionner un bénéficiaire.") }
                                    </div>
                                )) }

                                <div className="mt-4 col-lg-4">
                                    <label
                                        htmlFor="nouveauNom"
                                        className='form-label'>
                                        Nouveau nom de famille
                                    </label>
                                    <input
                                        id="nouveauNom"
                                        name="nouveauNom"
                                        type="text"
                                        value={ nouveauNom?.value }
                                        onChange={ handleNouveauNom }
                                        className='form-control'
                                        placeholder='ex: DUBOIS'/>

                                    { submitted && nouveauNom?.invalid
                                        && renderError(nouveauNom?.invalid) }
                                </div>

                                <div className="mt-4">
                                    <label
                                        htmlFor={ JUSTIFICATIF_NOM?.NAME }
                                        className="form-label">
                                        { getLabelInput(JUSTIFICATIF_NOM) }
                                    </label>
                                    <br/>
                                    <small>(Acte de mariage, Acte de partenariat civil (PACS), Décret de changement de nom, Jugement de changement de nom, Acte de naissance mis à jour)</small>
                                    <input
                                        type="file"
                                        className="form-control"
                                        id={ JUSTIFICATIF_NOM?.NAME }
                                        name={ JUSTIFICATIF_NOM?.NAME }
                                        onChange={ handleFileChange }
                                        ref={ documentJustificatifRef }
                                    />

                                    { submitted && !documentJustificatif
                                        && renderError(JUSTIFICATIF_NOM?.ERRORS?.MANDATORY) }
                                </div>

                                    <MessageInfoEnvoi
                                        isSuccess={ sendSuccess?.isSuccess }
                                        message={ sendSuccess?.message }
                                        display={ sendSuccess?.display }
                                    />
                            </div>

                            <div className="card-footer">
                                <div className='d-flex justify-content-end'>
                                    <button
                                        type='submit'
                                        className="btn btn-primary"
                                        // disabled={ !idBeneficiaireSelected || !documentJustificatif || !nouveauNom }
                                    >
                                        Envoyer
                                    </button>
                                    <button
                                        type='button'
                                        onClick={ ()  => erasedInputs(true)}
                                        className="btn btn-secondary ms-2"
                                    >
                                        Effacer
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </main>
        </div>
    )
}